export enum LocalizationId {
    InvalidFileFormat = "shared-messages.toast.invalid_file_format",
}
